export default __webpack_public_path__ + "static/media/shabaan.01978e39.png";